module.exports = __webpack_public_path__ + "img/rollIcv.921ba060.png";